// src/components/kidsa/KidsaHero.tsx
import React from 'react';

interface KidsaHeroProps {
  title: string;
  subtitle: string;
  description: string;
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
  heroImage: string;
  heroBackgroundImage: string;
}

const KidsaHero: React.FC<KidsaHeroProps> = ({
  title,
  subtitle,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  heroImage,
  heroBackgroundImage
}) => {
  return (
    <section className="hero-section hero-4 bg-cover fix" style={{ backgroundImage: `url(${heroBackgroundImage})` }}>
      <div className="ocean">
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
      <div className="doll-shape float-bob-x">
        <img src="/assets/kidsa/assets/img/hero/sun.png" alt="shape-img" />
      </div>
      <div className="line-shape">
        <img src="/assets/img/hero/line.png" alt="shape-img" />
      </div>
      <div className="bee-shape float-bob-y">
        <img src="/assets/img/hero/roket.png" alt="shape-img" />
      </div>
      <div className="line-2">
        <img src="/assets/img/line-1.png" alt="shape-img" />
      </div>
      <div className="star-shape">
        <img src="/assets/img/hero/star-2.png" alt="shape-img" />
      </div>
      <div className="frame-shape">
        <img src="/assets/img/value/shape-1.png" alt="shape-img" />
      </div>
      <div className="hero-content">
        <div className="row g-4 align-items-center">
          <div className="col-lg-6">
            <div className="hero-content">
              <h3 className="wow fadeInUp" dangerouslySetInnerHTML={{ __html: subtitle}}></h3>
              <h1 
                className="wow fadeInUp "
                data-wow-delay=".3s"
                dangerouslySetInnerHTML={{ __html: title }}
              ></h1>
              <p className="wow fadeInUp" data-wow-delay=".5s">{description}</p>
              <div className="hero-button">
                <a href={primaryButtonLink} className="theme-btn wow fadeInUp" data-wow-delay=".7s">
                  {primaryButtonText} <i className="fa-solid fa-arrow-right-long"></i>
                </a>
                <a href={secondaryButtonLink} className="theme-btn transparent wow fadeInUp" data-wow-delay=".8s">
                  {secondaryButtonText} <i className="fa-solid fa-arrow-right-long"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hero-image-area">
              <div className="hero-image wow fadeInRight" data-wow-delay=".3s">
                <img src="/assets/kidsa/assets/img/hero/02.png" alt="shape-img"  />
              </div>
              <div className="hero-bg wow fadeInUp" data-wow-delay=".5s" >
  <img 
    src={heroImage} 
    alt="hero-img" 
    
  />
</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaHero;
